export const SHOW_ALERT_MESSAGE_WITH_REDIRECT = 'alert/SHOW_ALERT_MESSAGE_WITH_REDIRECT';
export const SHOW_ALERT_MESSAGE = 'alert/SHOW_ALERT_MESSAGE';
export const HIDE_ALERT_MESSAGE = 'alert/HIDE_ALERT_MESSAGE';

const initialState = {
    showAlert: false,
    alertType: '',
    alertMessage: '',
    redirectUrl: '',
    alertTitle: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_ALERT_MESSAGE_WITH_REDIRECT:
            return {
                ...state,
                showAlert: true,
                alertType: 'restricted',
                alertMessage: action.message,
                redirectUrl: action.redirectUrl
            };
        case SHOW_ALERT_MESSAGE:
            return {
                ...state,
                showAlert: true,
                alertType: 'custom',
                alertMessage: action.message,
                alertTitle: action.title
            };
        case HIDE_ALERT_MESSAGE:
            return {
                ...state,
                showAlert: false,
                alertMessage: ''
            };
        default:
            return state
    }
}

export const showAlertMessageWithRedirect = (message, redirectUrl) => {
    return dispatch => {
        dispatch({
            type: SHOW_ALERT_MESSAGE_WITH_REDIRECT,
            message: message,
            redirectUrl: redirectUrl
        });
    }
};

export const showAlertMessage = (message, title) => {
    return dispatch => {
        dispatch({
            type: SHOW_ALERT_MESSAGE,
            message: message,
            title: title
        });
    }
};

export const hideAlertMessage = () => {
    return dispatch => {
        dispatch({
            type: HIDE_ALERT_MESSAGE
        });
    }
};